import { useController, type Control, type FieldPath, type FieldValues } from 'react-hook-form'
import { Checkbox, type CheckboxProps } from '@/components/ui/Checkbox'

export interface FormCheckboxProps<TFieldValues extends FieldValues>
  extends Omit<CheckboxProps, 'isSelected' | 'onChange'> {
  control: Control<TFieldValues>
  name: FieldPath<TFieldValues>
}

export function FormCheckbox<TFieldValues extends FieldValues>({
  control,
  name,
  ...props
}: FormCheckboxProps<TFieldValues>) {
  const { field } = useController({
    control,
    name,
  })

  return (
    <Checkbox
      {...props}
      isSelected={!!field.value}
      onChange={(isSelected) => field.onChange(isSelected)}
    />
  )
}

export default FormCheckbox
